export default __webpack_public_path__ + "static/media/volkswagen1.33c49baf.png";